import { theme } from 'src/providers/ThemeProvider'

export const selectProfileStyles = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  backgroundColor: theme.colors.white01,
  color: theme.colors.gray14,
  fontFamily: theme.fonts.interFont,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '18px',
  height: '38px',
  padding: theme.spacing(1, 0.5),

  '& .MuiSvgIcon-root': {
    fontSize: 22,
    marginTop: theme.spacing(-0.375)
  },

  '& .MuiBox-root': {
    marginRight: theme.spacing(1)
  }
}
